import {computed, ref} from "vue";
import {endpoints} from "~/network/endpoints.js";
import {useHttpRequest} from "~/composables/useHttpRequest";

export function useMailer() {
  const {httpRequest} = useHttpRequest();

  const filterQueryToFilters = (query) => {
    //Convert query string to object
    const filters = {
      fromWebSearch: true
    };
    if (query) {
      try {
        const decoded = atob(query);
        const parsed = JSON.parse(decoded);
        for (const key in parsed) {
          if (parsed[key] !== null && parsed[key] !== undefined) {
            filters[key] = parsed[key];
          }
        }
      } catch (e) {
        console.error("Failed to parse filter query:", e);
      }
    }
    return filters;
  };
  const filtersToQuery = (filters) => {
    //Convert object to json and then base64 encode it
    return btoa(JSON.stringify(filters));
  };

  const message = ref(null);
  const subject = ref(null);
  const sendLoading = ref(false);
  const sendErrors = ref({});
  const sendResult = ref({});

  // kind: a super admin's choice of SentMailKind (useMailKinds). Left out for a
  // club admin, whose mail is always the club's own.
  const sendMail = async (filters, kind = null) => {
    sendErrors.value = {};
    sendResult.value = {};
    sendLoading.value = true;

    try {
      const data = {
        subject: subject.value,
        message: message.value,
        filters: {
          ...filters,
          fromWebSearch: true,
        },
        ...(kind ? {kind} : {}),
      };
      sendResult.value = await httpRequest(endpoints.users.mail, data);
      subject.value = null;
      message.value = null;
    } catch (e) {
      sendErrors.value = e;
    } finally {
      sendLoading.value = false;
    }
  };

  return {
    message,
    subject,
    sendErrors,
    sendResult,
    sendLoading,
    sendMail,
    filterQueryToFilters,
    filtersToQuery
  };
}
